import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import CallIcon from '@mui/icons-material/Call';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import React from 'react';
import Card from '../card';

interface IContactUs {
  data: ICompany;
  cards: IContactUsCards;
}

const ContactUsCard: React.FC<IContactUs> = ({ data, cards }) => {
  const cardsData = [
    {
      title: cards.email,
      desc1: data?.coordonnees?.email,
      desc2: data?.coordonnees?.email2,
      icon: <AlternateEmailIcon fontSize="large" color="primary" />,
    },
    {
      title: cards.address,
      desc1: data?.address[0].label,
      desc2: data?.address[1].label,
      icon: <LocationOnIcon fontSize="large" color="primary" />,
    },
    {
      title: cards.phone,
      desc1: data.coordonnees.phone,
      desc2: data.coordonnees.WhatsApp,
      icon: <CallIcon fontSize="large" color="primary" />,
    },
  ];
  return (
    <Box sx={{ py: 12 }}>
      <Container>
        <Grid container spacing={4}>
          {cardsData.map((el, i) => (
            <Grid key={el.title} item xs={12} md={4}>
              <Card
                title={el.title}
                desc1={el.desc1}
                desc2={el.desc2}
                icon={el.icon}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ContactUsCard;
